export const FlightChangeDatesPageStep = {
  SELECT_FLIGHTS_TO_CHANGE: 'SELECT_FLIGHTS_TO_CHANGE',
  SELECT_DATES_TO_CHANGE: 'SELECT_DATES_TO_CHANGE',
  SELECT_NEW_FLIGHTS: 'SELECT_NEW_FLIGHTS',
  INSURANCE_SELECT_DATES: 'INSURANCE_SELECT_DATES',
  REVIEW_AND_PAY: 'REVIEW_AND_PAY',
} as const

export type FlightChangeDatesPageStepDefinition = typeof FlightChangeDatesPageStep[keyof typeof FlightChangeDatesPageStep]

export const FLIGHTS_CHECKOUT_HEADER_STEPS: Array<App.Checkout.CheckoutStep> = [
  {
    label: 'Change Flights',
    key: FlightChangeDatesPageStep.SELECT_FLIGHTS_TO_CHANGE,
    subSteps: [],
    isRoute: false,
  },
  {
    label: 'Select dates',
    key: FlightChangeDatesPageStep.SELECT_DATES_TO_CHANGE,
    subSteps: [],
    isRoute: true,
  },
  {
    label: 'New Flights',
    key: FlightChangeDatesPageStep.SELECT_NEW_FLIGHTS,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Insurance',
    key: FlightChangeDatesPageStep.INSURANCE_SELECT_DATES,
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Review & Pay',
    key: FlightChangeDatesPageStep.REVIEW_AND_PAY,
    isRoute: true,
    subSteps: [],
  },
]
